import { createSelector } from "reselect";

import { ApplicationState } from "../../applicationState";
import { PartialCustomerModelInRedux } from "../customer";
import { customerSelector } from "../customer/selectors";

import { CustomerTeam } from "./model";
import { routeName } from "./routes";

export const routeIdSelector = (state: ApplicationState) => {
    return state.router.params!.teamId!;
};

export const teamsSelector = createSelector(
    customerSelector,
    (customer: PartialCustomerModelInRedux) => {
        return customer.teams;
    }
);

export const teamSelector = createSelector(
    teamsSelector,
    routeIdSelector,
    (teams: CustomerTeam[] | undefined, id: string) => {
        return teams?.find(t => t.id === id);
    }
);

export const basePathSelector = (state: ApplicationState) => {
    return state.router.pathname!.substring(0, state.router.pathname!.indexOf(routeName) + routeName.length);
};
